/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { UsersAuthzResetGroupPermissionsManagedPermissionsMutationResponse, UsersAuthzResetGroupPermissionsManagedPermissionsPathParams, UsersAuthzResetGroupPermissionsManagedPermissions401, UsersAuthzResetGroupPermissionsManagedPermissions403 } from "../models/UsersAuthzResetGroupPermissionsManagedPermissions";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { usersAuthzResetGroupPermissionsManagedPermissions } from "../axios/usersAuthzResetGroupPermissionsManagedPermissions";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const usersAuthzResetGroupPermissionsManagedPermissionsMutationKey = () => [{ url: '/users-authz/v1/groups/:groupId/permissions/reset' }] as const

export type UsersAuthzResetGroupPermissionsManagedPermissionsMutationKey = ReturnType<typeof usersAuthzResetGroupPermissionsManagedPermissionsMutationKey>

export function usersAuthzResetGroupPermissionsManagedPermissionsMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = usersAuthzResetGroupPermissionsManagedPermissionsMutationKey()
        return mutationOptions<UsersAuthzResetGroupPermissionsManagedPermissionsMutationResponse, ResponseErrorConfig<UsersAuthzResetGroupPermissionsManagedPermissions401 | UsersAuthzResetGroupPermissionsManagedPermissions403>, {groupId: UsersAuthzResetGroupPermissionsManagedPermissionsPathParams["groupId"]}, TContext>({
          mutationKey,
          mutationFn: async({ groupId }) => {
            return usersAuthzResetGroupPermissionsManagedPermissions(groupId, config)
          },
        })

}

/**
 * @description Requires CLIENT_ADMIN role or client API key
 * @summary Reset all permissions for a group
 * {@link /users-authz/v1/groups/:groupId/permissions/reset}
 */
export function useUsersAuthzResetGroupPermissionsManagedPermissions<TContext>(options: 
{
  mutation?: UseMutationOptions<UsersAuthzResetGroupPermissionsManagedPermissionsMutationResponse, ResponseErrorConfig<UsersAuthzResetGroupPermissionsManagedPermissions401 | UsersAuthzResetGroupPermissionsManagedPermissions403>, {groupId: UsersAuthzResetGroupPermissionsManagedPermissionsPathParams["groupId"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? usersAuthzResetGroupPermissionsManagedPermissionsMutationKey()

          const baseOptions = usersAuthzResetGroupPermissionsManagedPermissionsMutationOptions(config) as UseMutationOptions<UsersAuthzResetGroupPermissionsManagedPermissionsMutationResponse, ResponseErrorConfig<UsersAuthzResetGroupPermissionsManagedPermissions401 | UsersAuthzResetGroupPermissionsManagedPermissions403>, {groupId: UsersAuthzResetGroupPermissionsManagedPermissionsPathParams["groupId"]}, TContext>
          

          return useMutation<UsersAuthzResetGroupPermissionsManagedPermissionsMutationResponse, ResponseErrorConfig<UsersAuthzResetGroupPermissionsManagedPermissions401 | UsersAuthzResetGroupPermissionsManagedPermissions403>, {groupId: UsersAuthzResetGroupPermissionsManagedPermissionsPathParams["groupId"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<UsersAuthzResetGroupPermissionsManagedPermissionsMutationResponse, ResponseErrorConfig<UsersAuthzResetGroupPermissionsManagedPermissions401 | UsersAuthzResetGroupPermissionsManagedPermissions403>, {groupId: UsersAuthzResetGroupPermissionsManagedPermissionsPathParams["groupId"]}, TContext>
      
}